import type {AiChatGeneratedAsset} from '@AiChat/ai-chat.types';

export interface AiChatAssetsVideoPreviewProps {
  asset: AiChatGeneratedAsset;
  onClose: VoidFunction;
}

export const VIDEO_PREVIEW_INDEX = 0;
